import React, { useState } from 'react';
import { modalStyles as styles } from './modalStyles';
import { formatAddress } from '../addressUtils';
import { useAuth } from '@clerk/clerk-react';
import RmaCustomerSummary from './RmaCustomerSummary';
import CloseCaseAction from './CloseCaseAction';

const API_BASE = process.env.REACT_APP_API_URL;

export default function RmaModalReady({ rma, onClose, onSave }) {
  const [trackingNumber, setTrackingNumber] = useState(rma.trackingNumber || '');
  const { getToken } = useAuth();

  const handleConfirm = async () => {
    try {
      const token = await getToken();
      const res = await fetch(`${API_BASE}/rma/${rma._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          status: 'Shipped',
          trackingNumber,
          internalNotes: `Tracking Number: ${trackingNumber}`,
        }),
      });
      const data = await res.json();
      onSave(data);
    } catch (err) {
      console.error('Failed to mark as shipped', err);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>CONFIRM SHIPPING</h2>
        <RmaCustomerSummary rma={rma} />
        <h3>{rma.serialNumber}</h3>
        <p>
          <strong>Ship To:</strong>{' '}
          {rma.shippingAddress && rma.shippingAddress.recipientName
            ? (
                <span style={{ whiteSpace: 'pre-line' }}>
                  {formatAddress(rma.shippingAddress)}
                </span>
              )
            : 'awaiting customer location'}
        </p>
        <p>Attach shipping label and insert tracking number</p>

        <input
          type="text"
          placeholder="Tracking Number"
          value={trackingNumber}
          onChange={e => setTrackingNumber(e.target.value)}
          style={styles.input}
        />

        <button onClick={handleConfirm} style={styles.button}>CONFIRM</button>
        <button onClick={onClose} style={styles.buttonAlt}>Cancel</button>
        <div style={{ marginTop: '0.75rem', textAlign: 'right' }}>
          <CloseCaseAction rma={rma} onSave={onSave} />
        </div>
      </div>
    </div>
  );
}

